import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'

import Directives from './utils/directives'
import i18n from './lang' // internationalization
import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log

import * as filters from './filters' // global filters
import ElTreeGrid from 'element-tree-grid'
import JsonViewer from 'vue-json-viewer'
import './styles/removal.css'
import getWS from '@/utils/ws'
import { VuePlugin } from 'vuera'
import { getDeviceProfile } from '@/utils/device'

getDeviceProfile().catch(() => {})

Vue.use(VuePlugin)
Vue.use(Directives)
// 导出一个初始化 ws 的方法，供 user.js 调用
export function initWSIfLogin() {
  const token = store.state.user.token
  const name = store.state.user.name

  // 需要 token 和 name 才允许建连
  if (token && name) {
    // 已有且处于 OPEN，直接返回，避免重复建连
    if (Vue.prototype.$ws && Vue.prototype.$ws.ws && Vue.prototype.$ws.ws.readyState === WebSocket.OPEN) {
      return
    }
    // 有旧实例但非 OPEN，尝试关闭后再重建
    if (Vue.prototype.$ws && Vue.prototype.$ws.ws && Vue.prototype.$ws.ws.readyState !== WebSocket.CLOSED) {
      try { Vue.prototype.$ws.ws.close() } catch (e) { console.log(e) }
    }
    Vue.prototype.$ws = getWS(name)
    if (process.env.NODE_ENV !== 'production') {
      console.log('WebSocket 已初始化，user:', name)
    }
  } else {
    // 未登录或信息不全，确保清理
    if (Vue.prototype.$ws && Vue.prototype.$ws.ws) {
      try { Vue.prototype.$ws.ws.close() } catch (e) { console.log(e) }
    }
    Vue.prototype.$ws = null
    if (process.env.NODE_ENV !== 'production') {
      console.log('未登录/信息不全，不初始化 WebSocket')
    }
  }
}

const unwatch = store.watch(
  s => [s.user.token, s.user.name],
  ([token, name]) => {
    if (token && name) {
      initWSIfLogin()
      unwatch() // 只触发一次
    }
  },
  { immediate: true }
)

/* 23123311321 */

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
/*
if (process.env.NODE_ENV === 'production') {
  const { mockXHR } = require('../mock')
  mockXHR()
}
*/

Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})
Vue.component(ElTreeGrid.name, ElTreeGrid)
Vue.use(JsonViewer)
/* 提示快速封装 */
import '@/components/Larke/tip'

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
